import { Box, Divider, IconButton, InputBase, Skeleton, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getConfirmedOrders, getConfirmedOrdersLoader } from 'redux/reducers/orders/selectors';
import { useParams } from 'react-router';
import {
	getConfirmedOrdersForFilterIdSuccess,
	getConfirmedOrdersRequest,
	getConfirmedOrdersSuccess,
} from 'redux/reducers/orders/reducer';
import { Notice } from 'ui/Notice';
import { nanoid } from '@reduxjs/toolkit';
import { Check, Close } from '@mui/icons-material';
import { useDebounce } from 'use-debounce';
import { TStep0Props } from './types';
import { OrdersTable } from './OrdersTable';

const ROWS = Array.from(new Array(4));

export const Step0: FC<TStep0Props> = ({
	easOrderId,
	setEasOrderId,
	externalOrderId,
	setExternalOrderId,
}) => {
	const params = useParams<{ orderId?: string }>();
	const orderIdParam = params.orderId ?? '';
	const dispatch = useDispatch();
	const confirmedOrder = useSelector(getConfirmedOrders);
	const confirmedOrderLoading = useSelector(getConfirmedOrdersLoader);

	// const [externalId, setExternalId] = useState<string | null>(null);
	const [externalIdDebounce] = useDebounce(externalOrderId, 800);

	useEffect(() => {
		if (!externalOrderId) {
			dispatch(getConfirmedOrdersSuccess(null));
			return;
		}
		// if (externalIdDebounce !== externalOrderId) {
		dispatch(
			getConfirmedOrdersRequest({
				filters: [
					{ fieldName: 'externalOrderId', value: `%${externalIdDebounce}%`, operator: 'like' },
				],
				pageNumber: 1,
				pageSize: 6,
			}),
		);
		// }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [externalIdDebounce]);

	const handleOrderId = (i: string) => {
		// if (Number.isNaN(+i)) return;
		setExternalOrderId(i);
		setEasOrderId(null);
		// setExternalId(i);
	};

	const handleSelectRow = (i: string) => {
		setExternalOrderId(i);
	};
	const handleEasOrderId = (easId: number) => {
		setEasOrderId(easId);
	};
	const handleClear = () => {
		setExternalOrderId('');
		setEasOrderId(null);
	};

	return (
		<Box
			sx={{
				mt: 5,
			}}
		>
			{confirmedOrder?.data[0]?.id === +orderIdParam ? (
				<OrdersTable
					externalId={externalOrderId}
					setExternalId={() => null}
					setEasId={() => null}
				/>
			) : (
				// <TextField
				// 	label="Store Order #"
				// 	variant="outlined"
				// 	sx={{
				// 		width: '100%',
				// 		'& .MuiInputBase-root': {
				// 			borderRadius: '12px',
				// 		},
				// 		'& input': {
				// 			color: easOrderId ? 'primary.main' : 'text.primary',
				// 			// backgroundColor: easOrderId ? 'primary.light' : 'white',
				// 			fontWeight: easOrderId ? 'bold' : 'normal',
				// 		},
				// 	}}
				// 	fullWidth
				// 	InputLabelProps={{ shrink: true }}
				// 	size="small"
				// 	value={externalOrderId ?? ''}
				// 	onChange={(e) => handleOrderId(e.target.value)}
				// />
				<Box
					component="div"
					sx={{
						p: '0px 0px',
						height: '38px',
						display: 'flex',
						alignItems: 'center',
						width: '100%',
						borderRadius: '12px',
						border: '1px solid #016193',
						// mb: '10px',
						fontSize: '.9rem',
						// p: 0,
					}}
				>
					{/* <Button
						color="primary"
						sx={{
							p: 0,
							m: 0,
							idTransform: 'none',
							fontWeight: '900',
							fontFamily: 'monospace',
							minWidth: '30px',
							textTransform: 'lowercase',
						}}
						//  onClick={handleClear}
					>
						i
					</Button>
					<Divider sx={{ height: 28 }} orientation="vertical" /> */}

					<InputBase
						sx={{
							ml: 1,
							flex: 1,
							fontSize: '.9rem',
							p: '2px 4px',
							'& input': {
								padding: '4px 4px',
								fontSize: '.9rem',
								color: easOrderId ? 'primary.main' : 'text.primary',
								fontWeight: easOrderId ? 'bold' : 'normal',
								backgroundColor: easOrderId ? 'primary.light' : 'white',
								borderRadius: '12px',
								paddingLeft: '10px',
								width: externalOrderId
									? `${String(+String(externalOrderId).length * 9.2)}px`
									: '100%',
								minWidth: 0,
								'&::placeholder': {
									fontSize: '.8rem',
								},
								fontFamily: 'monospace',
							},
						}}
						style={{ padding: 0 }}
						size="small"
						fullWidth
						placeholder="Enter Store's order #"
						inputProps={{
							autoComplete: 'new-password',
						}}
						onChange={(e) => handleOrderId(e.target.value)}
						value={externalOrderId ?? ''}
					/>
					<>
						<Divider sx={{ height: 28 }} orientation="vertical" />
						{!easOrderId ? (
							<Typography
								sx={{
									fontSize: '.9rem',
									color: 'primary.main',
									// fontWeight: 'bold',
									p: '0px 6px',
									backgroundColor: 'warning.light',
									// borderRadius: '12px',
									m: 0,
									height: '100%',
									alignItems: 'center',
									display: 'flex',
									justifyContent: 'center',
								}}
							>
								no selected order
							</Typography>
						) : (
							<Check
								fontSize="small"
								sx={{
									color: 'primary.main',
									p: '2px 4px',
								}}
							/>
						)}
					</>

					<Divider sx={{ height: 28 }} orientation="vertical" />
					<IconButton
						color="primary"
						// sx={{ p: '0 5px 0 5px' }}
						aria-label="directions"
						onClick={handleClear}
					>
						<Close fontSize="small" />
					</IconButton>
				</Box>
			)}
			{!confirmedOrderLoading &&
				externalOrderId &&
				confirmedOrder?.data[0]?.id !== +orderIdParam &&
				(confirmedOrder?.data?.length ?? 0) > 0 && (
					<OrdersTable
						externalId={externalOrderId}
						setExternalId={handleSelectRow}
						setEasId={handleEasOrderId}
					/>
				)}
			{!orderIdParam && confirmedOrderLoading && (
				<Box
					sx={{
						// pb: '1px',
						mt: 2,
					}}
				>
					{ROWS.map(() => (
						<Skeleton
							key={nanoid()}
							variant="rectangular"
							height="36px"
							sx={{
								mb: '36px',
							}}
						/>
					))}
				</Box>
			)}
			{!confirmedOrderLoading && externalOrderId && (confirmedOrder?.data?.length ?? 0) === 0 && (
				<Typography variant="h6" sx={{ mt: 2 }} color="primary">
					No orders found
				</Typography>
			)}
			{!confirmedOrderLoading && !externalOrderId && !orderIdParam && (
				<Notice text="If you cannot link the VAT Correction to a specific order then this field can be left blank" />
			)}

			{/* {!!typeOfReport && <Notice typeOfReport={typeOfReport} />} */}
		</Box>
	);
};
